import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { useAuth } from "auth";
import issuer_services from "services/issuer_services";
import { networkTypeSelector } from "store/userSliceHelpers";

export function useCardsCount() {
  const { user } = useAuth();
  const networkType = useSelector(networkTypeSelector);
  return useQuery({
    queryKey: ["cardsCount"],
    queryFn: () => issuer_services.getCardsCount(networkType),
    enabled: !!user,
  });
}
